import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const Loading = () => {
  return <InlineText2 color="current_color">Ищем позицию...</InlineText2>;
};
